export default "__VITE_ASSET__DRFs1xdK__"